export const i18nPdfPage = {
  headerTitle: 'Relatório de Monitoramento de Desempenho',
  headerSubtitle: 'Equipamento rotativo',
  system: 'Sistema/Subsistema',
  dimensions: 'Dimenções',
  cd: 'Desvio de condições',
  coverTitle: 'Relatório mensal',
  category: { RERT: 'Equipamento rotativo' },
  cover: {
    documentNumber: 'Número do documento',
    issueReason: 'Motivo do emissor',
    revision: 'Revisão',
  },
  caption: {
    critical: 'Condição crítica',
    potencial: 'Problema potencial',
    alarm: 'Condição de alarme',
    normal: 'Normal',
    notMonitored: 'Não monitorado',
    notOperated: 'Não operado',
  },
  normal: 'estava normal',
  label: {
    diagnosis: 'Diagnóstico',
    detailing: 'Detalhamento',
    deviationStart: 'Início do desvio',
    deviationEnd: 'Fim do desvio',
    conditionEvaluation: 'Avaliação da condição',
    recommendedAction: 'Ação recomendada',
    actionStatus: 'Status da ação',
    sapNote: 'Nota SAP / Status',
  },
  dimensions_label: {
    dynamic_condition: 'Condição Dinâmica',
    auxiliary_system: 'Sistema Auxiliar',
    oil_analysis: 'Análise de Óleo',
    process_condition: 'Condição do Processo',
  },
  summary: {
    cases: {
      title: 'Casos',
      total: 'Total',
    },
    severity: {
      title: 'Severidade',
      very_high: 'Muito Alto',
      high: 'Alto',
      medium: 'Médio',
      low: 'Baixo',
      very_low: 'Muito Baixo',
    },
    stage: {
      title: 'Etapa',
      diagnosis: 'Diagnóstico',
      actions: 'Ações',
      feedback: 'Resposta',
      closed: 'Fechado',
    },
  },
};
